export default class BenefitsNotesCtrl {
  $onInit() {
    this.getNotesValue();
  }

  getNotesValue() {
    this.getBenefitsNotes({ $e: { benefitsForm: this.insuranceData } });
  }
}
